import { Type } from 'class-transformer';
import { ResponsibleUserResultDto } from '../../_models/responsible-user-result-dto';

export class EmailReminderResultDto {
    @Type(() => ResponsibleUserResultDto)
    boardCommitteeMembers: ResponsibleUserResultDto[];

    @Type(() => ResponsibleUserResultDto)
    serviceTeam: ResponsibleUserResultDto[];

    @Type(() => ResponsibleUserResultDto)
    taskOwners: ResponsibleUserResultDto[];
}
